import axios from './axios';

export default {
  get(id) {
    return axios.get(`/configurations/${id}`);
  },
  list() {
    return axios.get('/configurations');
  },
  create(configuration) {
    return axios.post('/configurations', { configuration });
  },
  update(configuration) {
    return axios.put(`/configurations/${configuration.id}`, { configuration });
  },
  print({ id }, svg) {
    return axios({
      responseType: 'blob',
      method: 'POST',
      url: `/configurations/${id}/dossier_technique.pdf`,
      data: { svg },
    });
  },
  duplicate(id, configuration) {
    return axios.post(`/configurations/${id}/duplicate`, { configuration });
  },
  delete(id) {
    return axios.delete(`/configurations/${id}`);
  },
  askQuote(id, message) {
    return axios.post(`/configurations/${id}/ask_quote`, { id, message });
  },
};
